import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  UserDetailsInitialState,
  UserRolesType,
} from '../components/LoginForm/types';
import { RootState } from './rootReducer';
import {
  ALARM_ID_DECIMAL,
  ALARM_ID_HEXADECIMAL,
  UI_DATE_FORMAT,
} from '../common/constants';
import { System } from '../rtk/availableSystemApi';

export const userDetailsInitialState: UserDetailsInitialState = {
  isLoggedIn: false,
  userRoles: [],
  unitPreference: '',
  alarmIdRepresentation: ALARM_ID_DECIMAL,
  dateFormatPreference: UI_DATE_FORMAT,
  preferredSystems: [],
};

export const userDetailsSlice = createSlice({
  name: 'userDetails',
  initialState: userDetailsInitialState,
  reducers: {
    setLoginSuccess: (state) => {
      state.isLoggedIn = true;
    },
    setUserRoles: (state, action) => {
      state.userRoles = action.payload;
    },
    setUnitPreference: (state, action: PayloadAction<string>) => {
      state.unitPreference = action.payload;
    },
    setAlarmIdRepresentation: (
      state,
      action: PayloadAction<
        typeof ALARM_ID_HEXADECIMAL | typeof ALARM_ID_DECIMAL
      >,
    ) => {
      state.alarmIdRepresentation = action.payload;
    },
    setDateFormatPreference: (state, action: PayloadAction<string>) => {
      state.dateFormatPreference = action.payload;
    },
    setPreferredSystems: (state, action: PayloadAction<System[]>) => {
      state.preferredSystems = action.payload;
    },
  },
});

export const {
  setLoginSuccess,
  setUserRoles,
  setUnitPreference,
  setAlarmIdRepresentation,
  setDateFormatPreference,
  setPreferredSystems,
} = userDetailsSlice.actions;

export const userDetailsSelectors = {
  selectCurrentUserRoles: (state: RootState) => state.userDetails.userRoles,
  selectIsOnlyUser: (state: RootState) => {
    const userRoles = state.userDetails.userRoles;
    return userRoles.length === 1 && userRoles[0] === UserRolesType.User;
  },
  selectUnitPreference: (state: RootState) => state.userDetails.unitPreference,
  selectAlarmIdRepresentation: (state: RootState) =>
    state.userDetails.alarmIdRepresentation,
  selectDateFormatPreference: (state: RootState) =>
    state.userDetails.dateFormatPreference,
  selectPreferredSystems: (state: RootState) =>
    state.userDetails.preferredSystems ?? [],
};

export default userDetailsSlice.reducer;
